<template>
    <div class="pd-settings-view">
        <pd-settings-card class="mb-6"/>
        <ospi-number-card class="mb-6"/>
        <contracted-schedule-card/>
    </div>
</template>

<script>
    import PdSettingsCard from "./PdSettingsCard";
    import OspiNumberCard from "./OspiNumberCard";
    import ContractedScheduleCard from "../studyActivity/ContractedScheduleCard";

    /**
     * Professional Development > Settings: the career + renewal profile,
     * the OSPI certificate number and the contracted work schedule (the
     * latter two are the same cards Your Account uses). The Overview shows
     * the current values read-only and links here.
     */
    export default {
        name: "PdSettingsView",
        components: {PdSettingsCard, OspiNumberCard, ContractedScheduleCard},
    };
</script>
